import { useCallback, useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  ListGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { BsCaretUpFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Booking } from "../booking-page/store/slice";
import documentSlice, { Media } from "../documents/store/slice";
import styles from "./fileModal.module.scss";

type Props = {
  booking: Booking | null;
  isVisible: boolean;
  onHide: () => void;
};

const FilesModal = ({ booking, isVisible, onHide }: Props) => {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.documents.data);
  const isLoading = useSelector((state) => state.documents.isLoading);

  const request = useCallback(
    (bookingId: number) => dispatch(documentSlice.actions.request(bookingId)),
    [dispatch]
  );

  const download = useCallback(
    (document: Media) => dispatch(documentSlice.actions.download(document)),
    [dispatch]
  );

  const reset = useCallback(
    () => dispatch(documentSlice.actions.reset()),
    [dispatch]
  );

  useEffect(() => {
    if (booking && isVisible) {
      request(booking.id);
    }

    return () => {
      reset();
    };
  }, [booking, isVisible, request, reset]);

  return (
    <Modal
      show={isVisible}
      onHide={onHide}
      backdrop="static"
      fullscreen="lg-down"
    >
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>Files</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item className="text-secondary">
                <Row>
                  <Col>
                    Name <BsCaretUpFill style={{ fontSize: "12px" }} />{" "}
                  </Col>
                  <Col>Collection</Col>
                </Row>
              </ListGroup.Item>
              {!!(isLoading && data.length === 0) && (
                <Spinner
                  className={`text-primary ${styles.spinner}`}
                  animation="border"
                />
              )}
              {!!(!isLoading && data.length === 0) && (
                <ListGroup.Item className="text-secondary">
                  <Row>
                    <Col>No data</Col>
                    <Col />
                  </Row>
                </ListGroup.Item>
              )}
              {data.map((file, index) => (
                <ListGroup.Item key={index} className="link-primary">
                  <Row>
                    <Col>
                      <span
                        className={styles.download}
                        onClick={() => download(file)}
                      >
                        {file.name}
                      </span>
                    </Col>
                    <Col>
                      <Badge
                        bg={
                          file.collection_name.includes("success")
                            ? "success"
                            : file.collection_name.includes("fail")
                            ? "danger"
                            : "secondary"
                        }
                      >
                        {file.collection_name}
                      </Badge>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilesModal;
